import { render } from "./TaskAssignmentPage.vue?vue&type=template&id=93ae0094"
import script from "./TaskAssignmentPage.vue?vue&type=script&lang=js"
export * from "./TaskAssignmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__